import React from "react";
import { Link } from "react-router-dom";
import PolicyLayout, { PolicySection } from "./PolicyLayout";

function Cookies() {
  return (
    <PolicyLayout
      title="Cookie & Local Storage Policy"
      intro="This notice describes cookies and similar browser technologies used by the mefurvexo store. It should be read with the Privacy Policy."
      contactSubject="cookies or browser storage"
    >
      <PolicySection title="1. What these technologies are">
        <p>
          Cookies are small text files a website or service stores through a
          browser. Local storage is a related browser feature that can retain data
          on a device. Pixels, tags, and server logs can perform similar functions.
        </p>
      </PolicySection>

      <PolicySection title="2. Storage currently used by this store">
        <p>
          The store saves a <code>cartItems</code> entry in local storage so items,
          selected options, and quantities remain in the cart between page visits.
          It is essential to the cart experience and is not used for advertising.
          The website does not currently install its own analytics or advertising
          cookies.
        </p>
      </PolicySection>

      <PolicySection title="3. Third-party services">
        <p>
          Hosted payment pages, font or content-delivery services, and other
          external services may receive technical request data and may use their
          own storage under their notices. The payment provider&apos;s technologies
          operate after you move to its page and can be required for payment,
          security, and fraud prevention.
        </p>
      </PolicySection>

      <PolicySection title="4. Future optional technologies">
        <p>
          If optional analytics, preference, or advertising technologies are
          introduced, this notice will be updated and any consent control required
          by applicable law will be provided before they are activated. Consent to
          an optional category may be withdrawn through that control when present.
        </p>
      </PolicySection>

      <PolicySection title="5. Your controls">
        <p>
          Browser settings can inspect, block, or delete cookies and site data.
          Clearing local storage removes the saved cart. Blocking storage on a
          payment provider&apos;s page may prevent checkout from working. Browser
          &quot;Do Not Track&quot; signals are not interpreted uniformly; we respond to
          legally recognised preference signals where required.
        </p>
        <p>
          For information about related personal data, see the{" "}
          <Link to="/privacy">Privacy Policy</Link>.
        </p>
      </PolicySection>
    </PolicyLayout>
  );
}

export default Cookies;
